<template>
  <v-footer fixed app>
    <v-card class="flex gradient2">
      <v-card-actions>
        <span class="white--text ml-auto">
          &copy; 2018 -
          <strong>Ittention</strong>
        </span>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>


<script>
export default {
  name: "footernav"
};
</script>


<style scoped>
.gradient2 {
  /* background: linear-gradient(0.25turn, #81be6f, #50b6e5); */
}
</style>
